import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'setValues'})
export class SetValuesPipe implements PipeTransform {
    transform(value: any, args?: any[]): Object[] {
        return Array.from(value.values());
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/modals/pipes/set-values.pipe.ts